import React from 'react';

const Pricing = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <h1 className="text-3xl font-bold">Pricing</h1>
    </div>
  );
};

export default Pricing;
